// import $ from 'jquery';

$(() => {

	System.import(
		/* webpackChunkName: "vendor/jquery.scrolldepth@0.6" */
		'@vendor/jquery.scrolldepth@0.6'
	).then(() => {

		$.scrollDepth({
			minHeight: 2000,
			elements: [
				'.partners',
				'#clients',
				'#testimonials',
				'#careers',
				'#contact',
				'#contact-form',
				'footer'],
			percentage: true,
			userTiming: true,
			pixelDepth: true,
			nonInteraction: true
		});
	});

	$('a.scroll').click(function () {
		const currentLocation = location.pathname.replace(/^\//, '');

		if (currentLocation == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				if ($('#header').hasClass('hamburger-is-active')) {
					$('.hamburger').toggleClass('is-active');
					$('#header').toggleClass('hamburger-is-active');
				}
				var offset = target.offset().top - 90;
				$('html,body').animate({
					scrollTop: offset
				}, 1000);
				return false;
			}
			else {
				var parentSection = $(this).closest('section');
				target = $(parentSection).next('section');
				if (target.length) {
					var offset = target.offset().top - 90;
					$('html,body').animate({
						scrollTop: offset
					}, 1000);
					return false;
				}
			}
		}

	});

});


// WEBPACK FOOTER //
// ./client/src/site__fus078/components/scroll-to-section/index.js